import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import PlusBlackIcon from '@/images/plusBlack.svg';
import theme from '@/theme';
import { Button } from '@de-id/ui-components';
import styled from '@emotion/styled';
import { useWebhookComponentContext } from '../contex';
import { WebhookDialog } from './WebhookDialog';

const StyledButton = styled(Button)`
    white-space: nowrap;
    margin-left: auto;
`;

const WEBHOOK_LIMIT = 10;

export const WebhookAddButton = () => {
    const { setModalOpen, webhooks } = useWebhookComponentContext();

    const isLimitReached = webhooks.length >= WEBHOOK_LIMIT;

    const handleOpenModal = (): void => {
        setModalOpen(true);
    };

    return (
        <>
            <CustomTooltip
                title={isLimitReached ? `Maximum of ${WEBHOOK_LIMIT} webhooks allowed.` : ''}
                placement="top"
                arrow={true}
                containerHeight="fit-content"
                tooltipStyles={{
                    backgroundColor: theme.colors.secondary[900],
                    padding: '16px',
                    fontSize: '12px',
                }}
                slotProps={{
                    arrow: { sx: { color: theme.colors.secondary[900] } },
                }}>
                <StyledButton color="outlined" onClick={handleOpenModal} size="small" disabled={isLimitReached}>
                    <MaskedIcon src={PlusBlackIcon} size="20px" />
                    Add webhook
                </StyledButton>
            </CustomTooltip>
            <WebhookDialog />
        </>
    );
};
